/** Shown while the session or member loads. */
export function Splash({ label = 'Connecting' }: { label?: string }) {
  return (
    <div className="scanlines bg-hud-grid grid h-full place-items-center">
      <p className="hud-label animate-pulse-dot" role="status">
        {label}
      </p>
    </div>
  );
}
